// styles
import {
  InputTagsContainer,
  InputTagsField,
  InputLabel,
  TagsDisplay,
  TagPill,
  TagRemoveButton
} from './InputTags.styles.js';

export default function InputTags({ 
  pH="", 
  value, 
  updateValue, 
  id, 
  label, 
  onKeyDown,
  tags = [],
  onRemoveTag
}) {

  return (
      <InputTagsContainer>
          <InputTagsField
              className='panel-bg'
              type="text"
              onChange={(e) => updateValue(e.target.value)}
              onKeyDown={onKeyDown}
              placeholder=" "
              value={value}
              id={id}
          />
          <InputLabel htmlFor={id}>
              {label || pH}
          </InputLabel>
          
          {/* Display existing tags */}
          {tags.length > 0 && (
            <TagsDisplay>
              {tags.map((tag, index) => (
                <TagPill key={index}>
                  {tag}
                  <TagRemoveButton
                    type="button"
                    onClick={() => onRemoveTag && onRemoveTag(tag)}
                  >
                    ×
                  </TagRemoveButton>
                </TagPill>
              ))}
            </TagsDisplay>
          )}
      </InputTagsContainer>
  )
}
